import dayjs from 'dayjs'
export default function dateformat(value) {
  if (!value) {
    return ''
  } else {
    return dayjs(value).format('MM/DD/YYYY')
  }
}
